module.exports = {
    RESET_ALL_MATERIELS: 'RESET_ALL_MATERIELS',
    MAP_PANEL: 'MAP_PANEL',
    LIST_PANEL: 'LIST_PANEL',
    MATERIEL_TYPES: [
        { code: 'CENTRAL', id: 1, link: 'central', labelKey: 'central' },
        { code: 'SENSOR', id: 2, link: 'sensor', labelKey: 'sensor' },
        { code: 'POWER_SUPPLY', id: 3, link: 'powerSupply', labelKey: 'powerSupply' },
        { code: 'TELECOM', id: 6, link: 'telecom', labelKey: 'telecom' },
        { code: 'SIM', id: 4, link: 'sim', labelKey: 'sim' },
        { code: 'VARIOUS', id: 5, link: 'variousMateriel', labelKey: 'variousMateriel' },
        { code: 'EQUIPMENT', id: 7, link: 'equipment', labelKey: 'equipment' },
        { code: 'SUBSCRIPTION', id: 8, link: 'subscription', labelKey: 'subscription' },
        { code: 'ANTENNA', id: 9, link: 'antenna', labelKey: 'antenna' },
    ],
    MATERIEL_ASSIGNMENT_STATES: [
        { code: 1, label: 'onSite' },
        { code: 2, label: 'inStock' },
        { code: 3, label: 'maintenance' },
    ],
    MAT_CENTRAL: 'central',
    MAT_POWER_SUPPLY: 'powerSupply',
    MAT_SENSOR: 'sensor',
    MAT_TELECOM: 'telecom',
    MAT_SIM: 'sim',
    MAT_DIVERS: 'variousMateriel',
    MAT_EQUIPMENT: 'equipment',
    MAT_SUBSCRIPTION: 'subscription',
    MAT_ANTENNA: 'antenna',
    CENTRAL: 'CENTRAL',
    SIM: 'SIM',
    TELECOM: 'TELECOM',
    SENSOR: 'SENSOR',
    POWER_SUPPLY: 'POWER_SUPPLY',
    VARIOUS: 'VARIOUS',
    EQUIPMENT: 'EQUIPMENT',
    ANTENNA: 'ANTENNA',
    SUBSCRIPTION: 'SUBSCRIPTION',
    POWER_SUPPLY_PROBLEM: 'POWER_SUPPLY_PROBLEM',
    CENTRAL_ID: 1,
    SENSOR_ID: 2,
    POWER_SUPPLY_ID: 3,
    SIM_ID: 4,
    VARIOUS_ID: 5,
    TELECOM_ID: 6,
    EQUIPMENT_ID: 7,
    SUBSCRIPTION_ID: 8,
    ANTENNA_ID: 9,

    MAT_HEADERS_SUBSCRIPTION: ['type', 'provider', 'lineNumber', 'openDate', 'state', 'stateDate', 'assignment', 'administrator'],
    MAT_HEADERS_EQUIPEMEMENT: ['type', 'manufacturer', 'serialNumber', 'immoNum', 'purchaseDate', 'state', 'stateDate', 'assignment', 'central', 'sensor', 'powerSupply', 'telecom', 'variousMateriel', 'sim', 'administrator'],
    MAT_HEADERS_VARIOUS_MATERIAL: ['type', 'manufacturer', 'serialNumber', 'immoNum', 'purchaseDate', 'state', 'stateDate', 'assignment', 'administrator'],
    MAT_HEADERS_SIM: ['type', 'provider', 'serialNumberIccid', 'purchaseDate', 'state', 'stateDate', 'assignment', 'administrator'],
    MAT_HEADERS_TELECOM: ['type', 'manufacturer', 'imeiAndSerialNumber', 'immoNum', 'purchaseDate', 'state', 'stateDate', 'assignment', 'administrator'],
    MAT_HEADERS_POWERSUPPLIES: ['type', 'manufacturer', 'serialNumber', 'immoNum', 'purchaseDate', 'state', 'stateDate', 'assignment', 'administrator'],
    MAT_HEADERS_SENSORS: ['type', 'manufacturer', 'serialNumber', 'immoNum', 'purchaseDate', 'state', 'stateDate', 'assignment', 'scale', 'length', 'administrator'],
    MAT_HEADERS_CENTRAL: ['type', 'manufacturer', 'serialNumber', 'immoNum', 'purchaseDate', 'state', 'stateDate', 'assignment', 'administrator'],
    MAT_HEADERS_INVENTORY: ['type', 'manufacturer', 'serialNumber', 'immoNum', 'purchaseDate', 'state', 'stateDate', 'assignment', 'administrator'],
    MAT_HEADERS_ANTENNA: ['type', 'manufacturer', 'serialNumber', 'immoNum', 'name', 'purchaseDate', 'state', 'stateDate', 'assignment', 'city', 'administrator'],
}
